import { render, staticRenderFns } from "./ListData.vue?vue&type=template&id=0d21c68c&scoped=true&lang=pug&"
import script from "./ListData.vue?vue&type=script&lang=js&"
export * from "./ListData.vue?vue&type=script&lang=js&"
import style0 from "./ListData.vue?vue&type=style&index=0&id=0d21c68c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21c68c",
  null
  
)

export default component.exports